<template>
  <core-selection-toolbar-button
    premium
    :premium-feature-unlocked="hasVideoPlan"
    icon="i-ri-play-large-line"
    @click="mergeVideos"
  >
    Merge
  </core-selection-toolbar-button>
</template>

<script setup>
  import {storeToRefs} from 'pinia';

  const props = defineProps({
    context: Object,
    contextType: String
  });

  const selection = useSelection();
  const sessionStore = useSessionStore();
  const {currentUser} = storeToRefs(sessionStore);
  const videoEditorActions = useVideoEditorActions();
  const {openStorageUpsellModal, openVideoUpsellModal, openVideoMergeWelcomeModal} = useCommonModals();
  const hasVideoPlan = computed(() => Boolean(currentUser.value?.can?.transcodeVideo));

  async function mergeVideos() {
    useGtm().trackEvent({ event: 'core_ui-video_merge-click', action: 'click', category: 'video-editor' });
    await sessionStore.getCurrentUser();
    const currentUser = sessionStore.currentUser;
    const selectedFiles = selection.selected.value;
    const selectedVideos = selectedFiles.filter(file => file.is.video && !file.is.errored);

    if (!currentUser) return;

    if (!currentUser.can?.transcodeVideo) {
      openVideoUpsellModal({
        context: VIDEO_UPSELL_CONTEXTS.videoMerge
      });
      return;
    }

    if (currentUser.isStorageFull) {
      openStorageUpsellModal({
        context: STORAGE_UPSELL_CONTEXTS.videoMergeStorageFull
      });
      return;
    }

    const mergeParams = {
      files: selectedFiles,
      contextType: props.contextType,
      contextId: props.context?.id
    };

    if (
      selectedVideos.length >= 2 &&
      !sessionStore.isImpersonating &&
      !usePreferencesStore().currentUserPreferences[CURRENT_USER_PREFERENCES.onbVideoMergeDismissed]
    ) {
      const result = await openVideoMergeWelcomeModal(mergeParams);
      if (result === true) selection.clear();
      return;
    }

    const result = await videoEditorActions.mergeVideos(mergeParams);

    if (result === true) selection.clear();
  }
</script>
